var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"align":"center","dense":""}},[_c('v-col',[_c('search')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }